import styled from '@emotion/styled'
import { storeElement } from 'GlobalStores/StoreElement'
import { observer } from 'mobx-react-lite'
import { IconSpinner } from '../Spinner/IconSpinner'
import { Stack } from '@mui/material'

const CardFrontDrop = observer(props => {
    return (
        <CardFrontDropStyled display={storeElement.showCardFrontDrop ? 'inherit' : 'none'} id="card-front-drop">
            {/* {storeElement.showLoaderInCardFrontDrop && props.box === 'pre-summary' && (
                <Stack justifyContent={'center'} alignItems={'center'} width={'100%'} height={'100%'}>
                    <IconSpinner />
                </Stack>
            )}
            {!props.box === 'pre-summary' && (props.showLoader || storeElement.showLoaderInCardFrontDrop) && (
                <Stack justifyContent={'center'} alignItems={'center'} width={'100%'} height={'100%'}>
                    <IconSpinner />
                </Stack>
            )} */}
          
            {props.box === 'pre-summary' ? storeElement.showLoaderInCardFrontDrop ? <Stack justifyContent={'center'} alignItems={'center'} width={'100%'} height={'100%'}>
                    <IconSpinner />
                </Stack> : props.showLoader || storeElement.showLoaderInCardFrontDrop ? (
                    <Stack justifyContent={'center'} alignItems={'center'} width={'100%'} height={'100%'}>
                        <IconSpinner />
                    </Stack>
            ) : null : null}
            
        </CardFrontDropStyled>
    )
})

const CardFrontDropStyled = styled(Stack)`
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    border-radius: 12px;
    display: ${({ display }) => display};
    z-index: 2;
    top: 0;
    left: 0;
`

export default CardFrontDrop
